import { fetch } from '../request';
import type { IResponse, RequestConfig, ScenariosData, ScenariosDetailRequest } from '../interface';

export const getScenariosDetail = (params: ScenariosDetailRequest, config?: RequestConfig) =>
  fetch<IResponse<ScenariosData[]>>('/promotion_center/application_scene/', {
    method: 'GET',
    query: params,
    ...config,
  });

export enum SceneType {
  ENTERPRISE = 0,
  PERSONAL = 1,
}

export interface ApplicationSceneTag {
  id: number;
  is_new: boolean;
  is_hot: boolean;
  scene_type: SceneType; // 场景类型  0 企业 1 个人
  tag_name: string; // 标签名称
  tag_outer_id: string; // 标签外部ID
}

// /promotion_center/application_scene/service_platform_application_tags/
export const getApplicationSceneTags = (config?: RequestConfig) =>
  fetch<IResponse<ApplicationSceneTag[]>>(
    '/promotion_center/application_scene/service_platform_application_tags/',
    {
      method: 'GET',
      credential: false,
      ...config,
    },
  );
